"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordHealthService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordHealthService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordHealthService.instance) {
      return CordHealthService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordHealthService.instance = this;
  }
  getHealthCareProviders(city) {
    return this.get(`HealthCareProvider/HealthCareProviders?expression=${city}`);
  }
  medmijCollect(medmijId, medmijGd, redirect) {
    return this.get(`Medmij/Collect?MedmijId=${medmijId}&Redirect=${redirect}&MedmijGd=${medmijGd}`);
  }
  persistUserData(requestId) {
    return this.post(`medmij/persistUserData/${requestId}`, null);
  }
  getMedicinePrescription(applicationId, refresh) {
    return this.get(`MedicationPrescriptions/treatment/${applicationId}?refresh=${refresh}`);
  }
  getDoseUnit() {
    return this.get('medicationDoseUnit');
  }
  postMedicationPrescription(medicationPrescription) {
    return this.post('medicationPrescriptions', medicationPrescription);
  }
  updateMedicationPrescription(medicationPrescription, prescriptionId) {
    return this.put(`medicationPrescriptions/${prescriptionId}`, medicationPrescription);
  }
  deleteMedicationPrescription(prescriptionId) {
    return this.delete(`medicationPrescriptions/${prescriptionId}`);
  }
  getSupportedVersions() {
    return this.get('configuration/supportedversions');
  }
  getGpAppointments(refresh, limit, offset) {
    return this.get(`gpAppointments/${refresh}?offset=${offset}&limit=${limit}`);
  }
  getTokenForIvidoLabResultsAuth(email) {
    return this.get(`IvidoToken?email=${email}`);
  }
  // PRATEN MET SALUT
  startResponseForUser(startPMSResponse) {
    return this.post('pms/response/startresponse', startPMSResponse);
  }
  saveAndNext(saveAndNextRequest) {
    return this.post('pms/response/saveandnext', saveAndNextRequest);
  }
  deletePMSResponsesByUser() {
    return this.delete('pms/response/user');
  }
  deletePMSResponsesByResponseId(id) {
    return this.delete(`pms/response/${id}`);
  }
  // PMS TRIGGER
  getPMSTriggerAll() {
    return this.get('pms/trigger');
  }
  getPMSTriggerById(id) {
    return this.get(`pms/trigger/${id}`);
  }
  getPMSTriggerFilterByName(data) {
    return this.post('pms/trigger/filter', data);
  }
  // AAN DE SLAG
  getRandomChallenge(randomChallengeRequest) {
    return this.post('aandeslagresponse/random', randomChallengeRequest);
  }
  startChallenge(startChallengeRequest) {
    return this.post('aandeslagresponse', startChallengeRequest);
  }
  saveUserChallengeResponse(userChallengeId, saveChallengeRequest) {
    return this.patch(`aandeslagresponse/${userChallengeId}`, saveChallengeRequest);
  }
  getActiveChallengeForUser() {
    return this.get(`aandeslagresponse/user/active`);
  }
  getUserChallengeById(userChallengeId) {
    return this.get(`aandeslagresponse/${userChallengeId}`);
  }
  getAllUserChallenges() {
    return this.get('aandeslagresponse/user');
  }
  getLevelFeedback(levelFeedbackRequest) {
    return this.post('aandeslagresponse/levelfeedback', levelFeedbackRequest);
  }
  updateUserChallenge(userChallengeId, updateUserChallengeRequest) {
    return this.put(`aandeslagresponse/${userChallengeId}`, updateUserChallengeRequest);
  }
  getLevelPrompt(level) {
    return this.get(`aandeslagresponse/levelprompt/${level}`);
  }
  deleteADSResponsesByUser() {
    return this.delete('aandeslagresponse');
  }
  // PERSON
  getPersons(applicationId) {
    return this.get(`Person/${applicationId}`);
  }
  postPersons(person) {
    return this.post('Person', person);
  }
  updateGeneration(generationUpdateRequest) {
    return this.patch('Person', generationUpdateRequest);
  }
  // KEY - VALUE CONFIGURATION
  getAllKeyValue() {
    return this.get('KeyValue');
  }
  getKeyValueByConfigId(id) {
    return this.get(`KeyValue/${id}`);
  }
  createKeyValue(data) {
    return this.post('KeyValue', data);
  }
  updateKeyValue(data, id) {
    return this.put(`KeyValue/${id}`, data);
  }
  deleteAllKeyValue() {
    return this.delete('KeyValue');
  }
  deleteKeyValueByConfigId(id) {
    return this.delete(`KeyValue/${id}`);
  }
}
exports.CordHealthService = CordHealthService;
CordHealthService.instance = null;
